module.exports = __webpack_public_path__ + "img/john.ff65975e.png";